function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.023 12.324V30.7c0 .714-.688 1.299-1.53 1.299H3.978c-.844 0-1.531-.585-1.531-1.299V12.324c0-.723.687-1.299 1.53-1.299h4.516c.842 0 1.53.576 1.53 1.299zM19.69 1.514v28.964C19.69 31.32 19 32 18.158 32h-4.515c-.843 0-1.53-.68-1.53-1.522V1.514C12.113.679 12.8 0 13.643 0h4.515c.842 0 1.53.68 1.53 1.514zM29.553 7.98v22.498c0 .843-.696 1.522-1.54 1.522H23.5c-.843 0-1.53-.68-1.53-1.522V7.98c0-.835.687-1.514 1.53-1.514h4.515c.843 0 1.54.68 1.54 1.514z"
});

var SvgIFullstatistics = function SvgIFullstatistics(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIFullstatistics, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/i_fullstatistics.4c247c8a.svg";
export { ForwardRef as ReactComponent };